'use es6';

import http from 'hub-http-rxjs/clients/apiClient';
import { map } from 'rxjs/operators/map';
import Forms from '../models/Forms';
const getQuery = id => ({
  childType: 'FORM',
  fields: 'BASIC',
  id,
  levels: 0
});
export default {
  fetchFormsForPage(pageId) {
    return http.get('cosindex/api/v1/connections/children', {
      query: getQuery(pageId)
    }).pipe(map(Forms.fromJS));
  }
};